var map = {
	".": 78,
	"./": 78,
	"./App": 73,
	"./App.css": 295,
	"./App.test": 296,
	"./App.test.tsx": 296,
	"./App.tsx": 73,
	"./BarContainer": 127,
	"./BarContainer.module.scss": 23,
	"./BarContainer.tsx": 127,
	"./BlockContainer": 11,
	"./BlockContainer.module.scss": 187,
	"./BlockContainer.tsx": 11,
	"./BoardAnimation": 128,
	"./BoardAnimation.module.scss": 22,
	"./BoardAnimation.tsx": 128,
	"./BoardAnimation2": 129,
	"./BoardAnimation2.tsx": 129,
	"./BoardAnimation3": 130,
	"./BoardAnimation3.module.scss": 33,
	"./BoardAnimation3.tsx": 130,
	"./CharacterContainer": 131,
	"./CharacterContainer.module.scss": 143,
	"./CharacterContainer.tsx": 131,
	"./Dmm": 125,
	"./Dmm.module.scss": 55,
	"./Dmm.tsx": 125,
	"./FixedContainer": 344,
	"./FixedContainer.module.scss": 49,
	"./FixedContainer.tsx": 344,
	"./FixedContainerIPA": 353,
	"./FixedContainerIPA.module.scss": 29,
	"./FixedContainerIPA.tsx": 353,
	"./FrontPage": 354,
	"./FrontPage.module.scss": 24,
	"./FrontPage.tsx": 354,
	"./Header": 122,
	"./Header.module.scss": 42,
	"./Header.tsx": 122,
	"./Helper": 6,
	"./Helper.js": 6,
	"./LoadingLogo": 124,
	"./LoadingLogo.module.scss": 91,
	"./LoadingLogo.tsx": 124,
	"./LoadingScreen": 123,
	"./LoadingScreen.module.scss": 186,
	"./LoadingScreen.tsx": 123,
	"./OptionContainer": 132,
	"./OptionContainer.module.scss": 92,
	"./OptionContainer.tsx": 132,
	"./PageFive": 134,
	"./PageFive.module.scss": 21,
	"./PageFive.module2.scss": 709,
	"./PageFive.module3.scss": 710,
	"./PageFive.tsx": 134,
	"./PageFive2": 135,
	"./PageFive2.tsx": 135,
	"./PageFive3": 136,
	"./PageFive3.tsx": 136,
	"./PageFour": 137,
	"./PageFour.module.scss": 93,
	"./PageFour.tsx": 137,
	"./PageSix": 139,
	"./PageSix.module.scss": 58,
	"./PageSix.tsx": 139,
	"./PageThree": 140,
	"./PageThree.module.scss": 94,
	"./PageThree.tsx": 140,
	"./PageTwo": 126,
	"./PageTwo.module.scss": 95,
	"./PageTwo.tsx": 126,
	"./SelectionContainer": 133,
	"./SelectionContainer.module.scss": 57,
	"./SelectionContainer.tsx": 133,
	"./SwiperContainer": 138,
	"./SwiperContainer.module.scss": 43,
	"./SwiperContainer.tsx": 138,
	"./TextContainer": 356,
	"./TextContainer.module.scss": 76,
	"./TextContainer.tsx": 356,
	"./TitleContainer": 17,
	"./TitleContainer.module.scss": 188,
	"./TitleContainer.tsx": 17,
	"./assets": 2,
	"./assets/": 2,
	"./assets/background/bg.jpg": 726,
	"./assets/dmm/arrow_common.gif": 727,
	"./assets/dmm/bg_bt_olgtop.gif": 728,
	"./assets/dmm/bg_navimain.gif": 729,
	"./assets/fixed_container": 59,
	"./assets/fixed_container/": 59,
	"./assets/fixed_container/Thumbs.db": 730,
	"./assets/fixed_container/button_1.png": 197,
	"./assets/fixed_container/button_2.png": 198,
	"./assets/fixed_container/button_3.png": 199,
	"./assets/fixed_container/button_4.png": 200,
	"./assets/fixed_container/button_5.png": 201,
	"./assets/fixed_container/download_bg-2.png": 731,
	"./assets/fixed_container/download_bg.png": 202,
	"./assets/fixed_container/icon_1.png": 203,
	"./assets/fixed_container/icon_2-2.png": 732,
	"./assets/fixed_container/icon_2.png": 204,
	"./assets/fixed_container/icon_3.png": 733,
	"./assets/fixed_container/index": 59,
	"./assets/fixed_container/index.ts": 59,
	"./assets/header": 60,
	"./assets/header/": 60,
	"./assets/header/NEW_JGG_LOGO.png": 734,
	"./assets/header/Thumbs.db": 735,
	"./assets/header/button_1.png": 206,
	"./assets/header/button_2.png": 207,
	"./assets/header/button_3.png": 208,
	"./assets/header/button_4.png": 209,
	"./assets/header/button_5.png": 210,
	"./assets/header/dash.png": 211,
	"./assets/header/header_bg.png": 736,
	"./assets/header/index": 60,
	"./assets/header/index.ts": 60,
	"./assets/header/jgg_logo.png": 205,
	"./assets/index": 2,
	"./assets/index.ts": 2,
	"./assets/loading_screen": 61,
	"./assets/loading_screen/": 61,
	"./assets/loading_screen/NEW_JGG_LOGO.png": 737,
	"./assets/loading_screen/base.png": 213,
	"./assets/loading_screen/frame.png": 214,
	"./assets/loading_screen/index": 61,
	"./assets/loading_screen/index.ts": 61,
	"./assets/loading_screen/jgg_logo.png": 212,
	"./assets/page_1": 62,
	"./assets/page_1/": 62,
	"./assets/page_1/Thumbs.db": 738,
	"./assets/page_1/arrow.png": 216,
	"./assets/page_1/box_1.png": 220,
	"./assets/page_1/box_2.png": 221,
	"./assets/page_1/download.png": 217,
	"./assets/page_1/download_2.png": 218,
	"./assets/page_1/frame.png": 219,
	"./assets/page_1/frontpage_video.mp4": 739,
	"./assets/page_1/index": 62,
	"./assets/page_1/index.ts": 62,
	"./assets/page_1/logo.png": 215,
	"./assets/page_1/tick.png": 222,
	"./assets/page_2/2_title.png": 740,
	"./assets/page_3": 63,
	"./assets/page_3/": 63,
	"./assets/page_3/2_icon1A.png": 223,
	"./assets/page_3/2_icon1B.png": 224,
	"./assets/page_3/2_icon2A.png": 225,
	"./assets/page_3/2_icon2B.png": 226,
	"./assets/page_3/2_icon3A.png": 227,
	"./assets/page_3/2_icon3B.png": 228,
	"./assets/page_3/2_icon4A.png": 229,
	"./assets/page_3/2_icon4B.png": 230,
	"./assets/page_3/2_icon5A.png": 231,
	"./assets/page_3/2_icon5B.png": 232,
	"./assets/page_3/2_icon6A.png": 233,
	"./assets/page_3/2_icon6B.png": 234,
	"./assets/page_3/3_001.png": 235,
	"./assets/page_3/3_002.png": 236,
	"./assets/page_3/3_003.png": 237,
	"./assets/page_3/3_004.png": 238,
	"./assets/page_3/3_005.png": 239,
	"./assets/page_3/3_006.png": 240,
	"./assets/page_3/3_pager.png": 741,
	"./assets/page_3/3_pager2.png": 742,
	"./assets/page_3/3_title.png": 246,
	"./assets/page_3/arrow_down.png": 242,
	"./assets/page_3/arrow_up.png": 243,
	"./assets/page_3/box.png": 245,
	"./assets/page_3/box_s.png": 244,
	"./assets/page_3/index": 63,
	"./assets/page_3/index.ts": 63,
	"./assets/page_3/road.png": 241,
	"./assets/page_4": 64,
	"./assets/page_4/": 64,
	"./assets/page_4/4_pager.png": 254,
	"./assets/page_4/4_pager2.png": 255,
	"./assets/page_4/4_title.png": 743,
	"./assets/page_4/5_image_1.jpg": 744,
	"./assets/page_4/5_image_1.png": 247,
	"./assets/page_4/5_image_2.jpg": 745,
	"./assets/page_4/5_image_2.png": 248,
	"./assets/page_4/5_image_3.jpg": 746,
	"./assets/page_4/5_image_3.png": 249,
	"./assets/page_4/5_image_4.jpg": 747,
	"./assets/page_4/5_image_4.png": 250,
	"./assets/page_4/5_image_5.jpg": 748,
	"./assets/page_4/5_image_5.png": 251,
	"./assets/page_4/index": 64,
	"./assets/page_4/index.ts": 64,
	"./assets/page_4/left_arrow.png": 252,
	"./assets/page_4/right_arrow.png": 253,
	"./assets/page_5": 65,
	"./assets/page_5/": 65,
	"./assets/page_5/5_title.png": 749,
	"./assets/page_5/box1.png": 256,
	"./assets/page_5/box1_bak.png": 750,
	"./assets/page_5/box1_bak3.png": 751,
	"./assets/page_5/box1_bak4.png": 752,
	"./assets/page_5/box1_step1.png": 753,
	"./assets/page_5/box1_step4.png": 754,
	"./assets/page_5/box2.png": 257,
	"./assets/page_5/index": 65,
	"./assets/page_5/index.ts": 65,
	"./assets/page_5/left_character.png": 258,
	"./assets/page_5/right_character.png": 259,
	"./assets/page_52": 66,
	"./assets/page_52/": 66,
	"./assets/page_52/5_title.png": 755,
	"./assets/page_52/Thumbs.db": 756,
	"./assets/page_52/box1.png": 260,
	"./assets/page_52/box1_bak.png": 757,
	"./assets/page_52/box1_bak2.png": 758,
	"./assets/page_52/box1_bak3.png": 759,
	"./assets/page_52/box1bak3.png": 760,
	"./assets/page_52/box2.png": 261,
	"./assets/page_52/box2_step1.png": 761,
	"./assets/page_52/box2_step3.png": 762,
	"./assets/page_52/box2_step5.png": 763,
	"./assets/page_52/box2_step8.png": 764,
	"./assets/page_52/box2_step9.png": 765,
	"./assets/page_52/index": 66,
	"./assets/page_52/index.ts": 66,
	"./assets/page_52/left_character.png": 262,
	"./assets/page_52/right_character.png": 263,
	"./assets/page_53": 67,
	"./assets/page_53/": 67,
	"./assets/page_53/5_title.png": 766,
	"./assets/page_53/A/1.png": 268,
	"./assets/page_53/A/2.png": 269,
	"./assets/page_53/A/3.png": 270,
	"./assets/page_53/A/4.png": 271,
	"./assets/page_53/A/5.png": 272,
	"./assets/page_53/A/6.png": 273,
	"./assets/page_53/A/7.png": 274,
	"./assets/page_53/A/8.png": 275,
	"./assets/page_53/A/9.png": 276,
	"./assets/page_53/A/Thumbs.db": 767,
	"./assets/page_53/A/button_ig.png": 286,
	"./assets/page_53/A/button_twitter.png": 288,
	"./assets/page_53/B/1.png": 277,
	"./assets/page_53/B/2.png": 278,
	"./assets/page_53/B/3.png": 279,
	"./assets/page_53/B/4.png": 280,
	"./assets/page_53/B/5.png": 281,
	"./assets/page_53/B/6.png": 282,
	"./assets/page_53/B/7.png": 283,
	"./assets/page_53/B/8.png": 284,
	"./assets/page_53/B/9.png": 285,
	"./assets/page_53/B/Thumbs.db": 768,
	"./assets/page_53/B/button_ig.png": 287,
	"./assets/page_53/B/button_twitter.png": 289,
	"./assets/page_53/Thumbs.db": 769,
	"./assets/page_53/box3.png": 264,
	"./assets/page_53/box3_title.png": 265,
	"./assets/page_53/index": 67,
	"./assets/page_53/index.ts": 67,
	"./assets/page_53/left_character.png": 266,
	"./assets/page_53/right_character.png": 267,
	"./assets/page_53/tip.png": 290,
	"./assets/page_6": 68,
	"./assets/page_6/": 68,
	"./assets/page_6/Thumbs.db": 770,
	"./assets/page_6/bg.jpg": 771,
	"./assets/page_6/download_button.png": 292,
	"./assets/page_6/home_button.png": 293,
	"./assets/page_6/icon.png": 291,
	"./assets/page_6/index": 68,
	"./assets/page_6/index.ts": 68,
	"./assets/page_6/words.png": 294,
	"./data": 14,
	"./data.ts": 14,
	"./index": 78,
	"./index.css": 193,
	"./index.tsx": 78,
	"./react-app-env.d": 357,
	"./react-app-env.d.ts": 357,
	"./reportWebVitals": 141,
	"./reportWebVitals.ts": 141,
	"./setupTests": 358,
	"./setupTests.ts": 358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 391;